export default {
    formId: 'createSucursalForm', //'createSucursalForm',
    formField: {
      sucursal_name: {
        name: 'sucursal_name',
        label: 'Nombre Sucursal*',
        requiredErrorMsg: 'La sucursal es requerida.'
      },
      sucursal_address: {
        name: 'sucursal_address',
        label: 'Direccion Sucursal*',
        requiredErrorMsg: 'La direccion sucursal es requerida.'
      },
      workplace: {
        name: 'workplace',
        label: 'Sitio de trabajo',
        requiredErrorMsg: 'El sitio de trabajo es requerido.',
      },
      family_fund_compensation: {
        name: 'family_fund_compensation',
        label: 'Caja de compensacion',
        requiredErrorMsg: 'El Caja de compensacion es requerido.',
      },
      landline: {
        name: 'landline',
        label: 'Telefono fijo'
      },
      cell_phone: {
        name: 'cell_phone',
        label: 'Celular',
        requiredErrorMsg: 'El celular es requerido.'
      },
      country: {
        name: 'country',
        label: 'Pais',
        requiredErrorMsg: 'El pais es requerido.',
      },
      departament: {
        name: 'departament',
        label: 'Departamento',
        requiredErrorMsg: 'El departamento es requerido.'
      },
      municipaly: {
        name: 'municipaly',
        label: 'Municipio',
        requiredErrorMsg: 'El municipio es requerido.',
        // invalidErrorMsg: 'Card number is not valid (e.g. 4111111111111)'
      },
      arl: {
        name: 'arl',
        label: 'ARL Vinculada a la empresa',
        requiredErrorMsg: 'ARL Vinculada a la empresa es requerida.'
      },
      associated_bank: { 
        name: 'associated_bank',
        label: 'Banco asociado',
        requiredErrorMsg: 'Banco asociado es requerido.'
      },
      type_account_bank: {
        name: 'type_account_bank',
        label: 'Tipo de cuenta',
        requiredErrorMsg: 'Tipo de cuenta es requerida.'
      },
      account_number: {
        name: 'account_number',
        label: 'Numero de cuenta',
        requiredErrorMsg: 'Numero de cuenta es requerido.'
      },
      logo_sucursal: {
        name: 'logo_sucursal',
        label: 'Logo sucursal',
        requiredErrorMsg: 'Logo sucursal es requerido.'
      }, 
      logo_sucursal_name_saved_file: {
        name: 'logo_sucursal_name_saved_file',
        label: 'Logo sucursal',
        requiredErrorMsg: 'Logo sucursal es requerido.'
      }
    }
  };
  